import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../Style/ProjectDetails.css";
import axios from "axios";
import { AppLanguage } from "../context/ApplicationLanguage";
import { useTranslation } from "react-i18next";

const ProjectDetails = () => {
  const API_BASE_URL = "https://server-alwaleedstone.onrender.com";

  const [project, setProject] = useState(null);
  const [imageStone, setImageStone] = useState([]);
  const appLang = useContext(AppLanguage);
  const { id } = useParams();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(appLang.language);

    axios
      .get(`${API_BASE_URL}/api/project/${id}?lang=${appLang.language}`)
      .then((res) => {
        setProject(res.data);
        setImageStone(res.data.stone_images || []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id, appLang.language, i18n]);

  if (!project) {
    return <p>{t("loading")}</p>;
  }

  return (
    <div className="project1-details1">
      <section className="project-main-section1">
        <div className="project-info1">
          <h2>{project.project_name}</h2>
        </div>

        <div className="main-section-content1">
          <img
            src={project.project_image}
            alt={project.project_name}
            className="main-project-image1"
          />
          <p>{project.project_location}</p>
        </div>
      </section>

      {/* قسم صور الأحجار */}
      {imageStone.length > 0 ? (
        <section className="project-stone-section">
          <h3>{t("productsTitle")}</h3>
          <div className="stone-gallery">
            {imageStone.map((item, index) => (
              <img
                key={index}
                src={item.image}
                alt={`stone-${item.name}`}
                className="stone-image"
              />
            ))}
          </div>
        </section>
      ) : (
        <p style={{ textAlign: "center", marginTop: "20px" }}>
          {t("noImages")}
        </p>
      )}
    </div>
  );
};

export default ProjectDetails;
